import { __assign } from "tslib";
import React, { forwardRef } from 'react';
import MuiFade from '@material-ui/core/Fade';
import { useThemeProps } from '../../../foundation';
var _RcFade = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcFade' });
    return React.createElement(MuiFade, __assign({ ref: ref }, props));
});
var RcFade = _RcFade;
export { RcFade };
